import { widgetize, WidgetPropsMapping } from '@sg-widgets/react-core';
import { EWidgetsSgmDocs, IDocumentViewerComponentProps } from '..';
import { SGMDocsDocumentViewer } from './SGMDocsDocumentViewer';

widgetize(EWidgetsSgmDocs.DOCUMENT_VIEWER, SGMDocsDocumentViewer, {
  sgmDocsBaseUrl: WidgetPropsMapping.asString({
    description: 'SGMDocs base url',
  }),
  token: WidgetPropsMapping.asString({
    description: '[OPTIONAL] SGConnect token (will be resolved with local SGConnect token if not provided)',
  }),
  workspaceId: WidgetPropsMapping.asString({
    description: 'Workspace identifier',
  }),
  documentId: WidgetPropsMapping.asString({
    description: 'Document identifier',
  }),
  versionId: WidgetPropsMapping.asString({
    description: "[OPTIONAL] Document version identifier (will be resolved with 'last' value if not provided)",
  }),
  permalinkId: WidgetPropsMapping.asString({
    description: 'Permalink identifier',
  }),
  mimeType: WidgetPropsMapping.asString({
    description: "The document's content mimetype desired",
  }),
  hideDownloadButton: WidgetPropsMapping.asString({
    description:
      "[OPTIONAL] Set this to `true` if you do not want a download button when document can not be displayed (will be 'false' by default)",
  }),
  labels: WidgetPropsMapping.asObject({
    description: '[OPTIONAL] Labels',
  }),
  additionalClassNames: WidgetPropsMapping.asString({
    description: '[OPTIONAL] Add additional CSS class',
  }),
} as WidgetPropsMapping<IDocumentViewerComponentProps>);
